(function () {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  var parcelRequire = $parcel$global["parcelRequire7c47"];
var parcelRegister = parcelRequire.register;
parcelRegister("1yGYc", function(module, exports) {

$parcel$export(module.exports, "initCounters", function () { return $122a4c5fc2709739$export$8718aa02886ccbc7; });
var $122a4c5fc2709739$export$8718aa02886ccbc7 = function(counters) {
    var counterElements = counters !== null && counters !== void 0 ? counters : document.querySelectorAll(".c-counter");
    counterElements.forEach(function(counter) {
        var minus = counter.querySelector(".c-counter__button.--minus");
        var plus = counter.querySelector(".c-counter__button.--plus");
        var input = counter.querySelector(".c-counter__input");
        var valueVisual = counter.querySelector(".c-counter__value");
        if (!input) return;
        plus === null || plus === void 0 || plus.addEventListener("click", function(e) {
            e.preventDefault();
            if (input.max !== input.value) {
                input.stepUp();
                input.dispatchEvent(new Event("change"));
            }
        });
        minus === null || minus === void 0 || minus.addEventListener("click", function(e) {
            e.preventDefault();
            if (input.min < input.value) {
                input.stepDown();
                input.dispatchEvent(new Event("change"));
            }
        });
        input === null || input === void 0 || input.addEventListener("change", function() {
            if (valueVisual && input) valueVisual.innerHTML = input.value;
        });
    });
};
$122a4c5fc2709739$export$8718aa02886ccbc7(null);

});

parcelRegister("eTe7K", function(module, exports) {

$parcel$export(module.exports, "reinitHeaderCart", function () { return $ad712871b1d76d3c$export$f0cdeb1875f200b7; });

var $hlTU3 = parcelRequire("hlTU3");
var $ad712871b1d76d3c$var$initHeaderCart = function() {
    var mainHeaderCarts = document.querySelectorAll(".main-header-cart");
    var mobileQuery = window.matchMedia("(max-width: 61.999em)");
    mainHeaderCarts.forEach(function(item) {
        var openButton = item.querySelector(".main-header-cart__button-open");
        var panel = item.querySelector(".main-header-cart__panel");
        var closeButton = item.querySelector(".i-cart-overview__close-button");
        if (!panel) return;
        openButton === null || openButton === void 0 || openButton.addEventListener("click", function() {
            if (!mobileQuery.matches) return;
            panel === null || panel === void 0 || panel.classList.add("--open");
            document.body.classList.add("--disable-scroll");
        });
        closeButton === null || closeButton === void 0 || closeButton.addEventListener("click", function() {
            if (!panel) return;
            panel.style.pointerEvents = "none";
            setTimeout(function() {
                panel.style.removeProperty("pointer-events");
            }, 100);
            if (!mobileQuery.matches) return;
            panel === null || panel === void 0 || panel.classList.remove("--open");
            document.body.classList.remove("--disable-scroll");
        });
        mobileQuery.onchange = function() {
            panel === null || panel === void 0 || panel.classList.remove("--open");
            document.body.classList.remove("--disable-scroll");
        };
    });
};
var $ad712871b1d76d3c$export$f0cdeb1875f200b7 = function() {
    (0, $hlTU3.default)();
    $ad712871b1d76d3c$var$initHeaderCart();
};
$ad712871b1d76d3c$var$initHeaderCart();

});

parcelRegister("f1V7L", function(module, exports) {

$parcel$export(module.exports, "rerenderCartDropdown", function () { return $af1342b2ef412d84$export$2a4f0cafe1284aed; });

var $eXMKu = parcelRequire("eXMKu");

var $cSCLj = parcelRequire("cSCLj");

var $eTe7K = parcelRequire("eTe7K");

var $1yGYc = parcelRequire("1yGYc");
var $af1342b2ef412d84$export$2a4f0cafe1284aed = function(html, price, amount) {
    var headerCartOriginal = document.querySelector(".i-cart-overview");
    var itemsWrapper = document.querySelector(".i-cart-overview__products");
    var headerCartPriceWrapper = document.querySelector(".main-header-cart__value");
    var headerCartAmount = document.querySelector(".main-header-cart__amount");
    var scroll = itemsWrapper === null || itemsWrapper === void 0 ? void 0 : itemsWrapper.scrollTop;
    headerCartOriginal === null || headerCartOriginal === void 0 || headerCartOriginal.insertAdjacentHTML("afterend", html);
    headerCartOriginal === null || headerCartOriginal === void 0 || headerCartOriginal.remove();
    if (headerCartAmount) {
        headerCartAmount.innerHTML = amount.toString();
        if (amount > 0) headerCartAmount.classList.add("--active");
        else headerCartAmount.classList.remove("--active");
    }
    (0, $eTe7K.reinitHeaderCart)();
    (0, $eXMKu.initCartAll)();
    (0, $cSCLj.initCartSingle)();
    (0, $1yGYc.initCounters)(document.querySelectorAll(".i-cart-overview .c-counter"));
    if (headerCartPriceWrapper) headerCartPriceWrapper.innerHTML = price;
    var newItemsWrapper = document.querySelector(".i-cart-overview__products");
    newItemsWrapper === null || newItemsWrapper === void 0 || newItemsWrapper.scrollTo({
        top: scroll,
        behavior: "instant"
    });
};

});
parcelRegister("eXMKu", function(module, exports) {

$parcel$export(module.exports, "initCartAll", function () { return $ae4c63e2f516e677$export$a10b8735c6094d30; });

var $9WVoU = parcelRequire("9WVoU");

var $9BQeR = parcelRequire("9BQeR");

var $f1V7L = parcelRequire("f1V7L");
var $ae4c63e2f516e677$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $ae4c63e2f516e677$var$__generator = undefined && undefined.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var $ae4c63e2f516e677$export$a10b8735c6094d30 = function() {
    var dropdowns = document.querySelectorAll(".i-cart-overview");
    var progress = new (0, $9WVoU.ProgressItem)(document.querySelector(".i-progress"));
    dropdowns.forEach(function(dropdown) {
        var clearButton = document.querySelector(".--js-cart-clear");
        clearButton === null || clearButton === void 0 || clearButton.addEventListener("click", function(event) {
            return $ae4c63e2f516e677$var$__awaiter(void 0, void 0, void 0, function() {
                var response, data;
                return $ae4c63e2f516e677$var$__generator(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            event.preventDefault();
                            dropdown === null || dropdown === void 0 || dropdown.classList.add("--loading");
                            return [
                                4 /*yield*/ ,
                                (0, $9BQeR.cartApi).deleteAll()
                            ];
                        case 1:
                            response = _a.sent();
                            if (!response.ok) {
                                dropdown === null || dropdown === void 0 || dropdown.classList.remove("--loading");
                                return [
                                    2 /*return*/ 
                                ];
                            }
                            return [
                                4 /*yield*/ ,
                                response.json()
                            ];
                        case 2:
                            data = _a.sent();
                            console.log(data);
                            if (!data.success) {
                                dropdown === null || dropdown === void 0 || dropdown.classList.remove("--loading");
                                return [
                                    2 /*return*/ 
                                ];
                            }
                            if (data.progress.remaining && data.progress.percentage) progress.setProgress(data.progress.remaining, Number(data.progress.percentage));
                            (0, $f1V7L.rerenderCartDropdown)(data.headerDropdown, data.totalPrice.main, data.amount);
                            document.querySelectorAll(".i-cart").forEach(function(item) {
                                item.remove();
                            });
                            dropdown.classList.add("--open");
                            dropdown === null || dropdown === void 0 || dropdown.classList.remove("--loading");
                            return [
                                2 /*return*/ 
                            ];
                    }
                });
            });
        });
    });
};
$ae4c63e2f516e677$export$a10b8735c6094d30();

});
parcelRegister("9WVoU", function(module, exports) {

$parcel$export(module.exports, "ProgressItem", function () { return $73e60e7010814329$export$5862403450d02dea; });
$parcel$export(module.exports, "rerenderProgresses", function () { return $73e60e7010814329$export$23208ea4033bc752; });
var $73e60e7010814329$export$5862403450d02dea = /** @class */ function() {
    function ProgressItem(progressItem) {
        var _a, _b;
        this.progressItem = progressItem;
        this.remaining = (_a = progressItem === null || progressItem === void 0 ? void 0 : progressItem.querySelector(".i-progress__remaining")) !== null && _a !== void 0 ? _a : null;
        this.input = (_b = progressItem === null || progressItem === void 0 ? void 0 : progressItem.querySelector(".i-progress__input")) !== null && _b !== void 0 ? _b : null;
    }
    ProgressItem.prototype.setRemaining = function(remaining) {
        if (!this.remaining) return;
        this.remaining.innerHTML = remaining;
        this.progressItem.classList.toggle("--filled", parseFloat(remaining) <= 0);
    };
    ProgressItem.prototype.setPercentage = function(percentage) {
        if (!this.input) return;
        this.input.value = percentage;
    };
    ProgressItem.prototype.setProgress = function(remaining, percentage) {
        this.setRemaining(remaining);
        this.setPercentage(percentage);
    };
    return ProgressItem;
}();
var $73e60e7010814329$export$23208ea4033bc752 = function(remaining, percentage) {
    var progresses = document.querySelectorAll(".i-progress");
    progresses.forEach(function(item) {
        var progress = new $73e60e7010814329$export$5862403450d02dea(item);
        progress.setProgress(remaining, percentage);
    });
};

});


parcelRegister("cSCLj", function(module, exports) {

$parcel$export(module.exports, "initCartSingle", function () { return $9608988811818ab5$export$9ebe6dc0405923a8; });

var $9BQeR = parcelRequire("9BQeR");

var $f1V7L = parcelRequire("f1V7L");
var $9608988811818ab5$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $9608988811818ab5$var$__generator = undefined && undefined.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var $9608988811818ab5$export$9ebe6dc0405923a8 = function() {
    var dropdowns = document.querySelectorAll(".i-cart-overview");
    dropdowns.forEach(function(dropdown) {
        var items = dropdown.querySelectorAll(".i-product-overview, .i-coupon");
        items.forEach(function(item) {
            var _a, _b;
            var deleteButton = item.querySelector(".--js-cart-overview-remove");
            var counterInput = item.querySelector(".c-counter__input");
            var productId = (_a = item.dataset.productId) !== null && _a !== void 0 ? _a : null;
            var mass = (_b = item.dataset.mass) !== null && _b !== void 0 ? _b : null;
            counterInput === null || counterInput === void 0 || counterInput.addEventListener("change", function() {
                return $9608988811818ab5$var$__awaiter(void 0, void 0, void 0, function() {
                    var quantity, cartItemCounter, response, data;
                    return $9608988811818ab5$var$__generator(this, function(_a) {
                        switch(_a.label){
                            case 0:
                                if (!productId) {
                                    console.log("product id is missing");
                                    return [
                                        2 /*return*/ 
                                    ];
                                }
                                quantity = Number(counterInput.value);
                                cartItemCounter = document.querySelector('.--js-cart-counter[data-product-id="'.concat(productId, '"] .c-counter__input'));
                                if (cartItemCounter) {
                                    cartItemCounter.value = quantity.toString();
                                    cartItemCounter.dispatchEvent(new Event("change"));
                                }
                                return [
                                    4 /*yield*/ ,
                                    (0, $9BQeR.cartApi).change(productId, mass, quantity)
                                ];
                            case 1:
                                response = _a.sent();
                                if (!response.ok) return [
                                    3 /*break*/ ,
                                    3
                                ];
                                return [
                                    4 /*yield*/ ,
                                    response.json()
                                ];
                            case 2:
                                data = _a.sent();
                                if (!data.success) {
                                    item.classList.remove("--loading");
                                    return [
                                        2 /*return*/ 
                                    ];
                                }
                                (0, $f1V7L.rerenderCartDropdown)(data.headerDropdown, data.totalPrice.main, data.amount);
                                _a.label = 3;
                            case 3:
                                item.classList.remove("--loading");
                                return [
                                    2 /*return*/ 
                                ];
                        }
                    });
                });
            });
            deleteButton === null || deleteButton === void 0 || deleteButton.addEventListener("click", function() {
                return $9608988811818ab5$var$__awaiter(void 0, void 0, void 0, function() {
                    var cartItemButton, response, data;
                    return $9608988811818ab5$var$__generator(this, function(_a) {
                        switch(_a.label){
                            case 0:
                                if (!productId) {
                                    console.log("product id is missing");
                                    return [
                                        2 /*return*/ 
                                    ];
                                }
                                cartItemButton = document.querySelector('.--js-cart-remove[data-product-id="'.concat(productId, '"]'));
                                if (cartItemButton) {
                                    cartItemButton.dispatchEvent(new Event("click"));
                                    return [
                                        2 /*return*/ 
                                    ];
                                }
                                item.classList.add("--loading");
                                return [
                                    4 /*yield*/ ,
                                    (0, $9BQeR.cartApi).delete(productId, mass)
                                ];
                            case 1:
                                response = _a.sent();
                                if (!response.ok) return [
                                    3 /*break*/ ,
                                    3
                                ];
                                return [
                                    4 /*yield*/ ,
                                    response.json()
                                ];
                            case 2:
                                data = _a.sent();
                                if (!data.success) {
                                    item.classList.remove("--loading");
                                    return [
                                        2 /*return*/ 
                                    ];
                                }
                                item.classList.remove("--loading");
                                (0, $f1V7L.rerenderCartDropdown)(data.headerDropdown, data.totalPrice.main, data.amount);
                                _a.label = 3;
                            case 3:
                                return [
                                    2 /*return*/ 
                                ];
                        }
                    });
                });
            });
        });
    });
};
$9608988811818ab5$export$9ebe6dc0405923a8();

});


})();
//# sourceMappingURL=main.9834a192.js.map
